const SVG = ({ fill = 'currentColor', width = '16', height = '10', viewBox = '0 0 16 10' }) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 4.00015L5 4.00015L5 -4.80825e-07L-2.18557e-07 5L5 10L5 6.00015L16 6.00015L16 4.00015Z" />
  </svg>
)

export default SVG
